import { Badge } from "react-bootstrap";
import { DeviceStatus } from "../components/DeviceDetails";

export // Statusy urządzenia z dynamicznym stylem
const getStatusBadge = (status: DeviceStatus) => {
  switch (status) {
    case DeviceStatus.Active:
      return (
        <Badge className="m-1" bg="success">
          Aktywne
        </Badge>
      );
    case DeviceStatus.InRepair:
      return (
        <Badge className="m-1" bg="warning">
          W naprawie
        </Badge>
      );
    case DeviceStatus.Broken:
      return (
        <Badge className="m-1" bg="danger">
          Uszkodzone
        </Badge>
      );
    case DeviceStatus.Replacement:
      return (
        <Badge className="m-1" bg="info">
          Zastępcze
        </Badge>
      );
    default:
      return (
        <Badge className="m-1" bg="secondary">
          Nieznany status
        </Badge>
      );
  }
};
